import PropTypes from "prop-types";
import React from "react";
import { BrowserRouter } from "react-router-dom";

import BaseApp from "..";

const App = ({ state }) => <BaseApp state={state} Router={BrowserRouter} />;

App.propTypes = {
  state: PropTypes.object,
};

export default App;
